import React from 'react';
import { CreateCampaignForm } from '../../components/CreateCampaignForm/CreateCampaignForm';

export const CreateCampaign = () => <CreateCampaignForm />